// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + "f7dbe71a7c26b0e05cde" + ".styles.css";
};